class customDropdown extends HTMLElement {
  constructor() {
    super();

    this.triggerBtn = this.querySelector('[data-dropdown-trigger]');
    this.dropdownContentEle = this.querySelector('.dropdown-content');
    this.dropdownContentEles = this.querySelectorAll('.dropdown-content > a');
    this.input = this.querySelector('input[type="hidden"]');

    if (this.triggerBtn) {
      this.triggerBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = this.classList.contains('open');
        if (!isOpen) {
          const contentBlockHeight = Utility._getHeightofHiddenEle(this.dropdownContentEle);
          this.classList.add('open');
          this.dropdownContentEle.style.height = contentBlockHeight + 'px';
          setTimeout(() => {
            this.dropdownContentEle.style.height = '';
          }, 200);
        } else {
          this.dropdownContentEle.style.height = this.dropdownContentEle.offsetHeight + 'px';
          this.classList.remove('open');
          setTimeout(() => {
            this.dropdownContentEle.style.height = '0';
          }, 1);
          setTimeout(() => {
            this.dropdownContentEle.style.height = '';
          }, 200);
        }
      });
    }

    if (this.dropdownContentEles.length > 0) {
      this.dropdownContentEles.forEach(opt => {
        opt.addEventListener('click', (e) => {
          e.preventDefault();
          if (e.currentTarget.classList.contains('disabled')) return;
          this.input.value = e.currentTarget.dataset.value;
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
          this.triggerBtn.innerHTML = e.currentTarget.innerHTML;
          this.classList.remove('open');
          this.dropdownContentEles.forEach(opt => opt.classList.remove('selected'));
          e.currentTarget.classList.add('selected');
        });
      });
    }
  }
}
customElements.define('custom-dropdown', customDropdown);

class ringSizeWidget extends HTMLElement {
  constructor() {
    super();

    this.submitBtn = this.querySelector('#findSizeTrigger');
    this.resultEle = document.querySelector('[data-ring-size-result]');
    this.diameterSelectEle = this.querySelector('#inside_diameter');
    this.countrySelectEle = this.querySelector('input[name="country_selector"]');
    this.ringsizeSelectEle = this.querySelector('#ring_size');

    this.init();
  }

  onSelect = () => {
    this.diameterSelectEle.addEventListener('change', () => {
      this.ringsizeSelectEle.disabled = true;
      this.ringsizeSelectEle.value = '';
    });
    this.ringsizeSelectEle.addEventListener('change', () => {
      this.diameterSelectEle.disabled = true;
      this.diameterSelectEle.value = '';
    });
    this.countrySelectEle.addEventListener('change', (e) => {
      const country = e.currentTarget.value;
      this.ringsizeSelectEle.querySelectorAll('option').forEach(opt => {
        const matches = opt.value !== '' && opt?.dataset?.country?.includes(country) && opt.value !== '-';
        opt.disabled = !matches;
        opt.classList.toggle('d-none', !matches);
      });
      this.diameterSelectEle.disabled = false;
      this.diameterSelectEle.value = '';
      this.ringsizeSelectEle.value = '';
      this.ringsizeSelectEle.disabled = false;
    });
  }

  onSubmit = () => {
    if (!this.submitBtn) return;

    this.submitBtn.addEventListener('click', (e) => {
      e.preventDefault();

      if (this.diameterSelectEle.value !== '') {
        const diamOpt = this.diameterSelectEle.querySelector(`option[value="${this.diameterSelectEle.value}"]`);
        const auOpt = this.ringsizeSelectEle.querySelector(`option[data-index="${diamOpt?.dataset.index}"][data-country*="AU"]`);
        this._showResult(auOpt?.value || diamOpt?.dataset.size || '');

      } else if (this.ringsizeSelectEle.value !== '') {
        const allOpts = this.ringsizeSelectEle.querySelectorAll(`option[value="${this.ringsizeSelectEle.value}"]`);
        let rowIndex = null;
        allOpts.forEach(opt => {
          if (opt.dataset.country?.includes(this.countrySelectEle.value)) {
            rowIndex = opt.dataset.index;
          }
        });
        const auOpt = rowIndex !== null
          ? this.ringsizeSelectEle.querySelector(`option[data-index="${rowIndex}"][data-country*="AU"]`)
          : null;
        this._showResult(auOpt?.value || '');
      }

      this.diameterSelectEle.disabled = false;
      this.ringsizeSelectEle.disabled = false;
    });
  }

  _showResult = (value) => {
    this.resultEle.classList.add('animate');
    this.resultEle.querySelector('span').textContent = value;
    setTimeout(() => this.resultEle.classList.remove('animate'), 1000);
  }

  init = () => {
    this.onSelect();
    this.onSubmit();
    this.countrySelectEle.dispatchEvent(new Event('change'));
  }
}
customElements.define('ringsize-widget', ringSizeWidget);
